import { Text, Flex, UnorderedList, ListItem, Box } from "@chakra-ui/react";
const Scoring = () => {
  return (
    <Flex direction="column" margin="30px 60px" gap="15px">
      <Box>
        <Text fontStyle="italic">1. Bidding</Text>
        <UnorderedList marginLeft="60px">
          <ListItem>2</ListItem>
          <ListItem>3</ListItem>
          <ListItem>4</ListItem>
        </UnorderedList>
      </Box>
      <Box>
        <Text fontStyle="italic">2. Garbage Points</Text>
        <UnorderedList marginLeft="60px">
          <ListItem>
            Any extra points earned off your bid. For example, making four
            points when you only bid 3.
          </ListItem>
          <ListItem>
            These points can also be earned by non-bidders. For example, if your
            opponent bids 3, and you end up obtaining the Low, you would get one
            point added to your score.
          </ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  );
};
export default Scoring;
